import type { Optional } from '@festina-life/core'
import { createRequiredContext } from '@festina-life/ui/libs'

export type CommandActionsContextType = {
  tenantId: string
  scenarioId?: string
  commandId: Optional<string>
  shouldDisableMutationActions?: boolean
}

/** CommandData context for a life App. */
const [useCommandActionsContext, Provider] =
  createRequiredContext<CommandActionsContextType>('CommandActions')

export { Provider, useCommandActionsContext }
